export default "__VITE_ASSET__DyHBCrrD__"